var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagev3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4798 18.0253C12.6046 18.0326 14.7319 17.1406 16.2473 15.3428C18.5148 12.653 18.5861 8.61654 16.4086 5.85353C13.5739 2.25541 8.33788 2.03018 5.20166 5.177C2.90907 7.47654 2.41392 10.8835 3.69838 13.6702C3.80536 13.9377 4.21947 14.6728 4.49743 15.1565C4.65546 15.4314 4.63925 15.7705 4.45691 16.029C4.27376 16.2876 4.04199 16.6186 3.86128 16.8902C3.53793 17.3756 3.88153 18.0261 4.46339 18.0253L4.91451 18.0251C6.89309 18.0243 9.79035 18.023 10.4798 18.0253Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03711 8.29688H10.7609M8.03711 12.0644H13.4408",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagev3);
export default __webpack_public_path__ + "static/media/messagev3.d49ecd7a03b1e889d460efd460c33d34.svg";
export { ForwardRef as ReactComponent };